import React from 'react';

export const formatMonetaryAmount = (value: number, showCurrency = false) => {
  return showCurrency ? `${(value.toFixed(2))}₪` : `${value.toFixed(2)}`;
};

export const formatToIntegerValue = (e: React.ChangeEvent<HTMLInputElement>) => {
  return `${e.target.value}`.replace(/[^\d]/g, '');
};

export const formatFloatThousandsWithCommas = (x: string) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const formatUserFullName = (user: {profile: {firstName: string, lastName: string}} | null) => {
  return user ? [user.profile.firstName, user.profile.lastName].filter(Boolean).join(' ') : '';
};

export class Format {
  public static formatFloatThousandsWithCommas(value: number | string) {
    return value ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '';
  }

  public static displayFloatThousandsWithCommas(value: number | string) {
    return <bdi>{Format.formatFloatThousandsWithCommas(typeof value === 'number' ? value.toFixed(2) : value)}</bdi>;
  }

  public static formatToFloatValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    return `${e.target.value}`.replace(/[^.,\d]/, '');
  };

  public static formatValueToFixed(value: string, fractionDigits?: number) {
    return parseFloat(value) ? parseFloat(value.replace(',', '.')).toFixed(fractionDigits) : '';
  }

  public static formatUserName(firstName?: string, lastName?: string) {
    return [firstName, lastName].filter(Boolean).join(' ');
  }

  public static formatMonetaryAmount = (value: number, showCurrency = false) => {
    return showCurrency ? `${(value.toFixed(2))}₪` : `${value.toFixed(2)}`;
  }

  public static displayMonetaryAmount(value: number, showCurrency = false) {
    return <bdi>{Format.formatMonetaryAmount(value, showCurrency)}</bdi>;
  }
}



